import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Container } from "@/components/admin/Container";
import { Header } from "@/components/admin/Header";
import { Searchbar } from "@/components/admin/Searchbar";
import { capitalize } from "@/lib/utils";
import { PatientsTable } from "@/modules/patients/table";

export const Route = createFileRoute("/dashboard/patients/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	return (
		<>
			<Header
				breadcrumbs={[
					{
						label: capitalize(t(($) => $.modules.dashboard.title)),
						href: "/dashboard",
					},
					{ label: capitalize(t(($) => $.modules.patients.title)) },
				]}
			>
				<div className="ml-auto flex items-center space-x-4">
					<Searchbar />
				</div>
			</Header>
			<Container className="flex flex-col gap-4 p-4 lg:flex-row">
				<PatientsTable />
			</Container>
		</>
	);
}
